(function ($) {
  const $body = $("body");
  const $header = $("#site-header");
  const $menu = $("#menu-wrap");
  const $toggle = $("#mobile-menu-toggle");
  const $close = $("#mobile-menu-close");
  const speed = 300;
  const root = document.documentElement;

  const menu_bp = $header.data("menu-bp");

  function is_mobile_header() {
    return $header.hasClass("mobile");
  }

  function set_menu_scroll_lock(locked) {
    $body.toggleClass("menu-scroll-locked", !!locked);
  }

  function sync_header_initial_height() {
    const el = $header.get(0);
    if (!el) {
      return;
    }

    const main = el.querySelector(".header-main");
    if (!main) {
      root.style.setProperty("--header-initial-height", `${el.offsetHeight}px`);
      return;
    }

    // Padding animates on scroll. Subtract the current padding and add the
    // unscrolled padding so the value stays the initial height at every width.
    const initialPad =
      parseFloat(
        getComputedStyle(el).getPropertyValue("--header-padding-initial"),
      ) || 0;
    const mainStyles = getComputedStyle(main);
    const padTop = parseFloat(mainStyles.paddingTop) || 0;
    const padBottom = parseFloat(mainStyles.paddingBottom) || 0;
    const height = el.offsetHeight - padTop - padBottom + initialPad * 2;

    root.style.setProperty(
      "--header-initial-height",
      `${Math.round(height)}px`,
    );
  }

  function sync_header_metrics() {
    root.style.setProperty("--header-height", `${$header.outerHeight()}px`);
    sync_header_initial_height();

    if (is_mobile_header() || !$toggle.length) {
      return;
    }

    const headerEl = $header.get(0);
    const toggleEl = $toggle.get(0);
    if (!headerEl || !toggleEl) {
      return;
    }

    const headerRect = headerEl.getBoundingClientRect();
    const toggleRect = toggleEl.getBoundingClientRect();
    root.style.setProperty(
      "--menu-panel-left",
      `${Math.max(0, toggleRect.left - headerRect.left)}px`,
    );
  }

  // create focus trap
  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      sync_header_metrics();
      $toggle.addClass("is-active").attr("aria-expanded", "true");
      $menu.addClass("visible");
      $body.addClass("menu-open");
      set_menu_scroll_lock(is_mobile_header());
    },
    onDeactivate() {
      $toggle.removeClass("is-active").attr("aria-expanded", "false");
      $body.removeClass("menu-open");
      set_menu_scroll_lock(false);
      setTimeout(function () {
        $menu.removeClass("visible");
      }, speed);
    },
    initialFocus: false,
    allowOutsideClick: true,
  });

  function resize() {
    const was_mobile = is_mobile_header();
    $header.toggleClass("mobile", !ThemeJS.Media_Queries.is_at_least(menu_bp));
    sync_header_metrics();
    $menu.removeClass("mobile-transition-enabled");
    setTimeout(function () {
      $menu.addClass("mobile-transition-enabled");
    }, 0);

    // Desktop keeps page scroll; mobile locks it while open
    if ($body.hasClass("menu-open")) {
      set_menu_scroll_lock(is_mobile_header());
      // Close if crossing breakpoints so focus/layout stay coherent
      if (was_mobile !== is_mobile_header()) {
        focus_trap.deactivate();
      }
    }
  }

  // init header pad height and set header to fixed
  resize();
  $header.addClass("fixed");
  // trigger height recalculation on breakpoint change
  $(window).on("breakpoint_changed", resize);

  // Transparent at top → white after scrolling
  const scrollThreshold = 100;
  let scrollTicking = false;
  function updateHeaderScrollState() {
    $header.toggleClass("is-scrolled", window.scrollY > scrollThreshold);
    // Keep desktop panel glued to the shrinking/expanding header
    sync_header_metrics();
    scrollTicking = false;
  }
  function onScroll() {
    if (!scrollTicking) {
      window.requestAnimationFrame(updateHeaderScrollState);
      scrollTicking = true;
    }
  }
  updateHeaderScrollState();
  window.addEventListener("scroll", onScroll, { passive: true });

  // Header padding animates on scroll — keep metrics in sync during that transition
  $header
    .find(".header-main")
    .on("transitionrun transitionend", sync_header_metrics);

  function toggle_menu() {
    $body.hasClass("menu-open")
      ? focus_trap.deactivate()
      : focus_trap.activate();
  }

  // toggle hamburger drawer on click (all breakpoints)
  $toggle.click(toggle_menu);
  $close.click(() => focus_trap.deactivate());

  // function to set submenus open/close
  function set_submenu_open($li, opening) {
    let $btn = $("> .link-wrap button.sub-menu-toggle", $li);
    if (!$btn.length) {
      return;
    }
    let $submenu = $(`#${$btn.attr("aria-controls")}`);
    if (!$submenu.length) {
      return;
    }
    $btn.attr("aria-expanded", opening ? "true" : "false");
    $submenu
      .attr("aria-hidden", opening ? "false" : "true")
      [opening ? "slideDown" : "slideUp"](speed);
  }

  // toggle submenus on click of caret btns
  $header.on("click", "button.sub-menu-toggle", function () {
    set_submenu_open(
      $(this).closest("li"),
      $(this).attr("aria-expanded") == "false",
    );
  });

  // close desktop header submenus on tab out
  $header.on("focusout", ".desktop-only li.menu-item-has-children", function (e) {
    if ($header.hasClass("mobile") || $.contains(this, e.relatedTarget)) {
      return;
    }
    set_submenu_open($(this), false);
  });

  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $header.on("click", 'a[href="#"]', function (e) {
    e.preventDefault();
    let $btn = $("+ .sub-menu-toggle", this);
    if ($btn.length) {
      $btn.click();
    }
  });
})(jQuery);
